import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const IndividualAmenitie = ({ type, lenguage }) => {
  const AMENITIES = {
    wifi: {
      icon: 'fas fa-wifi',
      label: { EN: 'Wifi', ES: 'Wifi' },
    },
    coffee: {
      icon: 'fas fa-coffee',
      label: { EN: 'Unlimited Coffee', ES: 'Café ilimitado' },
    },
    parking: {
      icon: 'fas fa-car-side',
      label: { EN: 'Parking', ES: 'Estacionamiento' },
    },
    staff: {
      icon: 'fas fa-users',
      label: { EN: 'Staff', ES: 'Personal' },
    },
    cleaning_service: {
      icon: 'fas fa-broom',
      label: { EN: 'Cleaning Service', ES: 'Servicio de limpieza' },
    },
    printing_service: {
      icon: 'fas fa-print',
      label: { EN: 'Printing Service', ES: 'Servicio de impresión' },
    },
    common_areas: {
      icon: 'fas fa-building',
      label: { EN: 'Common Areas', ES: 'Áreas comunes' },
    },
    convention_hall: {
      icon: 'fas fa-chalkboard',
      label: { EN: 'Conference Room', ES: 'Sala de conferencias' },
    },
    snacks: {
      icon: 'fas fa-candy-cane',
      label: { EN: 'Snacks', ES: 'Snacks' },
    },
    phone_service: {
      icon: 'fas fa-phone',
      label: { EN: 'Phone Booths', ES: 'Cabinas telefónicas' },
    },
  };

  const amenity = AMENITIES[type];
  if (!amenity) return null;

  const text = lenguage === 'ES' ? ' ' + amenity.label.ES : ' ' + amenity.label.EN;

  return (
    <FlexContainer className="padlr6">
      <FlexContainer className="gap-4">
        <i className={`${amenity.icon} m-text-14 text-12`} />
        <Label className="text-14">{'   ' + text}</Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export const AmenitiesComponent = (props) => {
  const {
    wifi,
    coffee,
    parking,
    staff,
    cleaning_service,
    printing_service,
    common_areas,
    convention_hall,
    snacks,
    phone_service,
    lenguage,
  } = props;
  return (
    <FlexContainer className={'width100'}>
      <FlexContainer
        className={
          'width100 bgGrandientSkyBlue border-rad8px fontWhite m-flex-column padt20 padlr130 m-padlr20 gap-20 padb20'
        }
        style={{
          flexWrap: 'wrap',
        }}
      >
        <Label className={'text-16 width100 text-justify'}>
          <strong>{lenguage === 'EN' ? 'Popular Amenities' : 'Amenidades'}</strong>
        </Label>
        {wifi && <IndividualAmenitie type="wifi" lenguage={lenguage} />}
        {coffee && <IndividualAmenitie type="coffee" lenguage={lenguage} />}
        {parking && <IndividualAmenitie type="parking" lenguage={lenguage} />}
        {staff && <IndividualAmenitie type="staff" lenguage={lenguage} />}
        {cleaning_service && <IndividualAmenitie type="cleaning_service" lenguage={lenguage} />}
        {printing_service && <IndividualAmenitie type="printing_service" lenguage={lenguage} />}
        {common_areas && <IndividualAmenitie type="common_areas" lenguage={lenguage} />}
        {convention_hall && <IndividualAmenitie type="convention_hall" lenguage={lenguage} />}
        {snacks && <IndividualAmenitie type="snacks" lenguage={lenguage} />}
        {phone_service && <IndividualAmenitie type="phone_service" lenguage={lenguage} />}
      </FlexContainer>
    </FlexContainer>
  );
};
